import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { authAPI } from '@/lib/api';
import Sidebar from '@/components/Sidebar';
import CalendarView from '@/components/CalendarView';
import OpenPurchaseOrders from '@/components/OpenPurchaseOrders';
import EmployeeManagement from '@/components/EmployeeManagement';
import WorkOrderQueue from '@/components/WorkOrderQueue';
import AdminPanel from '@/components/AdminPanel';
import NetSuiteSettings from '@/components/NetSuiteSettings';

export default function DashboardPage({ token, setToken, user, setUser }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      if (!user && token) {
        try {
          const response = await authAPI.getMe();
          setUser(response.data);
        } catch (error) {
          console.error('Failed to fetch user:', error);
          setToken(null);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchUser();
  }, [token, user, setUser, setToken]);

  const handleLogout = () => {
    setToken(null);
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg font-medium text-muted-foreground">Loading...</div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-slate-50/50 dark:bg-slate-950/50" data-testid="dashboard-page">
      <Sidebar user={user} onLogout={handleLogout} />
      <main className="flex-1 overflow-auto">
        <Routes>
          <Route path="/" element={<CalendarView user={user} />} />
          <Route path="/purchase-orders" element={<OpenPurchaseOrders user={user} />} />
          <Route path="/employees" element={<EmployeeManagement user={user} />} />
          <Route path="/queue" element={<WorkOrderQueue user={user} />} />
          <Route 
            path="/admin" 
            element={
              user?.role === 'Administrator' ? (
                <AdminPanel user={user} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/settings" 
            element={
              user?.role === 'Administrator' ? (
                <NetSuiteSettings user={user} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
        </Routes>
      </main>
    </div>
  );
}
